import {
  Sword, Crosshair, Apple, Droplet, HeartPulse, Fuel, Backpack, Coins, Package, PackageOpen,
} from "lucide-react";

export const CATEGORIES = {
  weapon: { label: "Weapon", icon: Sword, color: "#f59e0b" },
  ammo: { label: "Ammo", icon: Crosshair, color: "#ef4444" },
  food: { label: "Food", icon: Apple, color: "#84cc16" },
  water: { label: "Water", icon: Droplet, color: "#0ea5e9" },
  medical: { label: "Medical", icon: HeartPulse, color: "#ec4899" },
  fuel: { label: "Fuel", icon: Fuel, color: "#a855f7" },
  gear: { label: "Gear", icon: Backpack, color: "#14b8a6" },
  currency: { label: "Currency", icon: Coins, color: "#eab308" },
  kit: { label: "Kit", icon: PackageOpen, color: "#10b981" },
  misc: { label: "Misc", icon: Package, color: "#94a3b8" },
};

export const CATEGORY_ORDER = [
  "weapon", "ammo", "food", "water", "medical", "fuel", "gear", "currency", "kit", "misc",
];

// Loadout templates — one-click starting kits.
export const TEMPLATES = {
  survival: {
    label: "Survival kit",
    items: [
      { name: "Ration packs", category: "food", quantity: 5, unit: "packs" },
      { name: "Water", category: "water", quantity: 3, unit: "L" },
      { name: "First-aid kit", category: "medical", quantity: 1, unit: "" },
      { name: "Flashlight", category: "gear", quantity: 1, unit: "" },
      { name: "Multi-tool", category: "gear", quantity: 1, unit: "" },
    ],
  },
  soldier: {
    label: "Soldier loadout",
    items: [
      { name: "Rifle", category: "weapon", quantity: 1, unit: "" },
      { name: "Rifle rounds", category: "ammo", quantity: 120, unit: "rounds" },
      { name: "Sidearm", category: "weapon", quantity: 1, unit: "" },
      { name: "Combat rations", category: "food", quantity: 3, unit: "packs" },
      { name: "Water", category: "water", quantity: 2, unit: "L" },
      { name: "Med pack", category: "medical", quantity: 1, unit: "" },
    ],
  },
  roadtrip: {
    label: "Road-trip supplies",
    items: [
      { name: "Fuel", category: "fuel", quantity: 1, unit: "tank" },
      { name: "Jerry can", category: "fuel", quantity: 2, unit: "cans" },
      { name: "Snacks", category: "food", quantity: 6, unit: "" },
      { name: "Water bottles", category: "water", quantity: 8, unit: "" },
      { name: "Spare tyre", category: "gear", quantity: 1, unit: "" },
      { name: "Cash", category: "currency", quantity: 200, unit: "" },
    ],
  },
};
